import { META_MODEL_CUT_SIZE_MULTIPLIER } from '../constants';

export const CSV_FILE_FORMAT_ERROR =
  'The CSV file should contain a single column with no header, and include only valid audience IDs';
export const VALID_FILE = 'Valid file';
export const ERROR_PROCESSING_FILE = 'Error occurred during file processing';
export const IN_PROGRESS = 'In Progress';
export const COPY_POPOVER_TITLE = 'Click to copy and view text';
export const CLICK_TO_VIEW_ERROR_DETAILS = 'Click to view error details';
export const IMPORTING_FILE = 'Importing file';
export const SUCCESS_FILE = 'Import Complete';
export const CHANGE_LOG = 'Change Log';
export const CHANGE_LOG_DATE = 'Date';
export const CHANGE_LOG_CHANGED_BY = 'Changed By';
export const CHANGE_LOG_CHANGED_FIELDS = 'Changed Fields';
export const NO_DATA = 'No Data';
export const JSON_VIEW = 'Json View';
export const FIELD_NAME = 'Field Name';
export const OLD_VALUE = 'Old Value';
export const NEW_VALUE = 'New Value';
export const TARGETING_TESTING = 'Targeting Testing';
export const USER_ID_EMAIL = 'User ID/Email';
export const CLEAR_FILTERS = 'Clear Filters';
export const TEST_TARGETING = 'Test Targeting';
export const DELETE_AB_TEST = 'Delete A/B Test';
export const CREATE = 'Create';
export const EDIT = 'Edit';
export const SAVE = 'Save';
export const SAVE_ANYWAY = 'Save Anyway';
export const CANCEL = 'Cancel';
export const WAIT = 'Wait';
export const DELETE = 'Delete';
export const SAVE_AUDIENCE = 'Save audience?';
export const YES = 'YES';
export const NO = 'NO';
export const AUDIENCE_HAS_BEEN_EDITED =
  'The audience has been edited, do you want to save and continue ?';
export const AUDIENCE_SIZE_STILL_FETCHING =
  'The seed audience size is still being calculated. Saving now may lead to an incorrect audience count being stored.';
export const PLEASE_FILL_OUT_ALL_POSSIBLE_RESPONSES =
  'Please fill out all possible responses.';
export const SUCCESSFULLY_CREATED_AB_TEST = 'Successfully created AB Test';
export const AB_TEST_NAME = 'A/B Test Name';
export const EDIT_AB_TEST = 'Edit A/B Test';
export const STEP_1 = 'Step 1';
export const STEP_2 = 'Step 2';
export const AB_TEST_1 = 'A/B Test 1';
export const SELECT_PLACEMENT = 'Select Placement';
export const TEST_TYPE = 'Test Type';
export const RANDOM = 'Random';
export const PERCENTAGE = 'Percentage';
export const SLOTS = 'Slots';
export const STATUS = 'Status';
export const STEP_3 = 'Step 3';
export const CLOSE = 'Close';
export const SELECT_CATEGORIES = 'All Categories';
export const REMOVE_AB_TEST = 'Remove A/B Test';
export const SUCCESSFULLY_DELETED_AB_TEST = 'Successfully deleted A/B Test';
export const FAILED_TO_DELETE_AB_TEST = 'Failed to delete A/B Test';
export const ERROR_FETCHING_GROUPS = 'Error fetching groups';
export const DUPLICATE = 'Duplicate';
export const NO_CURRENT_GROUP = 'No current group.';
export const UPLOADING = 'Uploading';

export const AUDIENCE_STUDIO = 'Audience Studio';
export const CUSTOM_AUDIENCES = 'Custom Audiences';
export const CREATE_AUDIENCE = 'Create Audience';
export const CREATE_GROUP = 'Create Group';
export const SELECT_GROUP = 'Select group';
export const ESTIMATED_AUDIENCE_SIZE = 'Estimated Audience Size';
export const MODELING_STATUS = 'Modeling Status';
export const SEED_AUDIENCE_SIZE = 'Seed Audience Size';
export const LAST_MODIFIED = 'Last modified';
export const NEW_GROUP = 'New Group';
export const HOW_TO_NAME_NEW_GROUP = 'How do you want to name the new group?';
export const MODEL_YOUR_AUDIENCE = 'Model your audience';
export const YOUR_AUDIENCE_IS_BEING_MODELED =
  'Your audience is getting modeled.';
export const YOUR_AUDIENCE_FAILED_TO_GET_MODELED =
  'Your audience failed to get modeled';
export const EST_AUDIENCE_SIZE_MODELED_VALIDATION_MESSAGE =
  'Modeling Error: Your ADS seed audience must contain over 1,000 individuals';
export const EST_AUDIENCE_SIZE_MODELED_WARNING_MESSAGE =
  'Warning: We suggest that your ADS seed audience contains at least 2,000 individuals';
export const AUDIENCE_NAME_LENGTH_VALIDATION_MESSAGE =
  'Audience name should not exceed 175 characters';
export const SELECT_AUDIENCE_SIZE_INFORMATION_TEXT =
  'A 1% lookalike consists of the people most similar to your lookalike audience source. Increasing the percentage creates a bigger, broader audience.';
export const EXPORT_HISTORY = 'Export History';
export const ADD_AUDIENCE_DETAILS = 'Add your audience details';

export const POINT_CHANGE_END_DATE_ERROR_MESSAGE =
  'End Date must be greater than Start Date';

export const AUDIENCE_EXPORT_SUCCESS_MESSAGE =
  'Success! Your audience is now being delivered.';
export const AUDIENCE_EXPORT_FAILED_MESSAGE = 'Your audience failed to export';
export const AUDIENCE_MODEL_SKIP_MESSAGE = `Increase the size of your audience by using Attain's look-alike machine learning models.`;
export const ACTIVE_AUDIENCES = 'Active Audience';
export const AUDIENCE_EXPORT_FIELD_TITLES = {
  ots_segment: 'The Trade Desk',
  custom_segment: 'The Trade Desk Custom',
  liveramp_custom_segment: 'Liveramp Custom',
  liveramp_ots_segment: 'Liveramp OTS',
  experian_ots_segment: 'Experian OTS',
  ttd_ots_segment_seed_audience: 'The Trade Desk (Seed)',
  ttd_custom_segment_seed_audience: 'The Trade Desk Custom (Seed)',
  liveramp_ots_segment_seed_audience: 'Liveramp OTS (Seed)',
  liveramp_custom_segment_seed_audience: 'Liveramp Custom (Seed)',
  meta_custom_segment_seed_audience: 'Meta',
  yahoo_dsp_ots_segment: 'Yahoo DSP OTS',
  yahoo_dsp_custom_segment: 'Yahoo DSP Custom',
  tiktok_custom_segment: 'TikTok Custom',
  tiktok_custom_segment_seed_audience: 'TikTok Custom (Seed)',
  reddit_custom_segment: 'Reddit Custom',
};

export enum LIVERAMP_SEGMENT_FIELD_NAME {
  PROGRAMMATIC_PERCENT_OF_MEDIA = 'Programmatic % of media',
  CPM = 'CPM',
  DESCRIPTION = 'Description',
  CUSTOM_SEGMENT_NAME = 'Custom Segment Name',
  TV_TARGETING = 'TV Targeting',
  ADVERTISER_DIRECT = 'Advertiser Direct % of Media',
  CHOOSE_INTEGRATION = 'Choose Integration (Destination)',
  CHOOSE_ADVERTISER = 'Choose Advertiser (Distribution Manager)',
}

export enum META_SEGMENT_FIELD_NAME {
  META_AD_ACCOUNT_ID = 'Meta Ad Account ID',
  MODEL_CUT_SIZE = 'Model Cut Size',
}

export enum YAHOO_DSP_SEGMENT_FIELD_NAME {
  PARTNER_ID = 'Partner ID (MDM ID)',
  TV_CPM = 'TV CPM',
}

export enum TIKTOK_SEGMENT_FIELD_NAME {
  ADVERTISER_ID = 'Advertiser ID',
  MOBILE_OS = 'Mobile OS',
  AUDIENCE_SIZE = 'Audience Size',
  PLACEMENTS = 'Placements',
}

export enum REDDIT_SEGMENT_FIELD_NAME {
  REDDIT_AD_ACCOUNT_ID = 'Reddit Ad Account ID',
}

// TikTok Mobile OS option labels
export const TIKTOK_MOBILE_OS_ALL = 'All';
export const TIKTOK_MOBILE_OS_ANDROID = 'Android';
export const TIKTOK_MOBILE_OS_IOS = 'IOS';

// TikTok Audience Size option labels
export const TIKTOK_AUDIENCE_SIZE_NARROW = 'Narrow';
export const TIKTOK_AUDIENCE_SIZE_BALANCED = 'Balanced';
export const TIKTOK_AUDIENCE_SIZE_BROAD = 'Broad';

// TikTok Placements option labels
export const TIKTOK_PLACEMENT_TIKTOK = 'TikTok';
export const TIKTOK_PLACEMENT_PANGLE = 'Pangle';
export const TIKTOK_PLACEMENT_GLOBAL_APP_BUNDLE = 'Global App Bundle';

// TikTok Placements tooltip
export const TIKTOK_PLACEMENTS_TOOLTIP =
  'Note: The Global App Bundle placement does not support the optimization goal Landing Page View (optimization_goal = TRAFFIC_LANDING_PAGE_VIEW). Pangle (Used to be TikTok_Audience_Network)';

export enum TRADE_DESK_SEGMENT_FIELD_NAME {
  ADVERTISER_ID = 'Advertiser ID',
  PARTNER_ID = 'Partner ID',
  PERCENT_OF_MEDIA = '% of media',
  CPM = 'CPM',
  DESCRIPTION = 'Description',
  CUSTOM_SEGMENT_NAME = 'Custom Segment Name',
  OTS_SEGMENT_NAME = 'OTS Segment Name',
}

export const AUDIENCE_MANAGER_COLUMN_TITLES = {
  GROUP: 'Group',
  NAME: 'Name',
  AUDIENCE_STATUS: 'Audience Status',
  TYPE: 'Type',
  PLATFORM: 'Platform',
  ESTIMATED_SIZE: 'Est. Size',
  LAST_MODIFIED: 'Last Modified',
};

export const EXPORT_HISTORY_HEADERS = {
  DATE_TIME: { label: 'Export Date', width: '7%' },
  PLATFORM: { label: 'Platform', width: '13%' },
  STATUS: { label: 'Status', width: '9%' },
  ESTIMATED_SIZE: { label: 'Est. Size', width: '9%' },
  CUT_SIZE: { label: 'Cut Size', width: '6%' }, 
  CPM: { label: 'CPM', width: '5%' },
  POM: { label: 'PoM', width: '5%' },
  EMAIL: { label: 'Email', width: '20%' },
  NAME: { label: 'Name', width: '26%' },
};

export const NO_RECORDS_FOUND = 'No records found';
export const ERROR_BOUNDARY_MESSAGE =
  'Whoops, looks like we had an error. Please return to the homepage or clear cache & re-login. If the error persists, please reach out to our team. Thanks!';
export const RETURN_TO_HOMEPAGE = 'Return to homepage';
export const CLEAR_CACHE_AND_RELOGIN = 'Clear cache & Re-login';
export const REDIRECTING = 'Redirecting...';
export const CLEARING_CACHE = 'Clearing cache...';

export const CLICKS = 'Clicks';
export const IMPRESSIONS = 'Impressions';
export const IN_HOUSE_LABEL = 'In-House';
export const TRANSUNION_LABEL = 'TransUnion';
export const RECOMMANDED = 'Recommended';
export const CHOOSE_AN_AUDIENCE_TYPE = 'Choose an audience type';
export const WAIT_FOR_AUDIENCE_LOAD = 'Wait for Audience Load';
export const EDIT_AUDIENCE_NAME = 'Edit Audience Name';
export const AUDIENCE_HISTORY = 'Audience History';
export const AUDIENCE_NAME = 'Audience Name';
export const SAVE_AUDIENCE_TITLE = 'Save Audience';
export const BUILD_FROM_SCRATCH = 'Build from scratch';
export const BUILD_FROM_SCRATCH_SUB_TEXT =
  'Target specific purchase behaviors, demographics, or survey questions';
export const COMBINE_EXISTING = 'Combine existing';
export const COMBINE_EXISTING_SUB_TEXT =
  'Combine your pre-existing ADS audiences into a single, new audience';
export const AUDIENCE_DESIGNER = 'Audience Designer';
export const AUDIENCE_DESIGNER_SUB_TEXT =
  'Use our Query Builder to target specific purchase behaviors, demographics, or survey questions';
export const AUDIENCE_BLENDER = 'Audience Blender';
export const AUDIENCE_BLENDER_SUB_TEXT =
  'Combine multiple modeled audiences into a single, new audience';
export const AUDIENCE_FILE = 'Audience File';
export const AUDIENCE_FILE_SUB_TEXT =
  'Upload your KloverIDs to generate a seed audience.';
export const CREATE_WITH_TRANSUNION = 'Create with TransUnion';
export const CREATE_WITH_IN_HOUSE = 'Create with In-House Modeling';
export const GROUP_DONE_NOT_HAVE_AUDIENCE = `This group doesn't have any audiences yet`;
export const GROUP_DONE_NOT_HAVE_AUDIENCE_WITH_FILTERS = `This group doesn't have any audiences with applied filters`;
export const CREATE_AUDIENCE_BY_CLICKING = `Start by clicking "Create Audience"`;
export const GETTING_AUDIENCE_BY_UPATING_FILTERS = `Start getting audience by updating applied filters`;
export const POINT_CHANGE_DATE = 'Date & Time';
export const POINT_CHANGE_VALUE = 'Value';
export const POINT_CHANGE_START_DATE = 'Points Change Start Date';
export const POINT_CHANGE_END_DATE = 'Points Change End Date';
export const POINT_CHANGE_START_VALUE = 'Points Change Start Value';
export const POINT_CHANGE_END_VALUE = 'Points Change End Value';
export const DATE_CANNOT_BE_IN_PAST = 'Date cannot be in the past';
export const DATE_CANNOT_BE_AFTER_90_DAYS = 'Date cannot be after 90 days';
export const ENTER_AUDIENCE_NAME_TO_CONTINUE =
  'Enter an audience name to continue';
export const PLEASE_REMOVE_HEADER_BEFORE_UPLOADING =
  'Please remember to remove header before uploading.';
export const META_MODEL_CUT_SIZE = `About ${META_MODEL_CUT_SIZE_MULTIPLIER}M IDs`;

export const AUDIENCE_MANAGER_FILTER_LABLES = {
  AUDIENCE_TYPE: 'All Types',
  PLATFORM: 'All Platforms',
};

export const PUSHER_ENV_MISSING_MESSAGE =
  'Pusher environment variables are missing';
export const PUSHER_CONNECTED_MESSAGE = 'Pusher connected successfully';
export const PUSHER_DISCONNECTED_MESSAGE = 'Pusher disconnected';
export const PUSHER_SUBSCRIBED_MESSAGE = 'Successfully subscribed to channel';
export const PUSHER_SUBSCRIBED_ERROR_MESSAGE = 'Failed to subscribe to channel';
export const PUSHER_CONNECTION_ERROR_MESSAGE = 'Pusher connection error';
export const PUSHER_CONNECTION_CLOSED_MESSAGE = 'Pusher connection closed';
export const PUSHER_EMAIL_VALIDATION_MESSAGE =
  'Email is required to create user channel';
export const SURVEY_MIN_ANSWER_REQUIRED =
  'At least one answer must be selected';
export const SURVEY_ADD_MIN_ANSWER_IN_SURVEY_TO_SAVE_AUDIENCE =
  'Add at least one answer in the survey to save the audience';
export const PAGE_NOT_FOUND_MESSAGE = '404 Error: This page does not exist.';
export const TYPE_AT_LEAST_3_CHARACTERS = 'Type at least 3 characters';

// Export Failure Log Popup
export const EXPORT_FAILURE_LOG_TITLE = 'Export Failure Log';
export const ERROR_CODE_LABEL = 'Error Code';
export const MESSAGE_LABEL = 'Message';
export const EXPORT_ID_LABEL = 'Export ID';
export const SUGGESTED_ACTION_LABEL = 'Suggested Action';
export const LAST_UPDATED_LABEL = 'Last Updated';
export const NO_ERROR_DETAILS_AVAILABLE = 'No error details available';
export const UNKNOWN_TIMESTAMP = 'Unknown';
export const VIEW_ERROR_CONTEXT = 'View error context';
export const EXPORT_TYPE_LABEL = 'Export Type';
export const PLATFORM_LABEL = 'Platform';

// HTTP Status Text
export const EXPORT_HISTORY_LOAD_ERROR_MESSAGE =
  'Failed to load export history. Please refresh the page.';

export const HTTP_STATUS_TEXTS: { [key: number]: string } = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
};
